import React from 'react'
import BurgerMenu from 'react-burger-menu'

import { styleResponsive, MenuLink, SubmenuLink, TitleMenu } from '../../style'

function MenuResponsive({ routes, isOpen }) {
  const Menu = BurgerMenu['slide']

  const items = []

  routes.map(route => {
    items.push(
      <MenuLink
        activeStyle={{
          color: 'white'
        }}
        key={route.pathname}
        to={route.pathname}
      >
        {route.api}
      </MenuLink>
    )
    route.content.map(({ parent, children, pathname }) => {
      items.push(<TitleMenu key={parent}>{parent}</TitleMenu>)
      children.map(child => {
        items.push(
          <SubmenuLink
            activeStyle={{
              color: 'white'
            }}
            key={child.pathname}
            to={route.pathname + pathname + child.pathname}
          >
            {child.name}
          </SubmenuLink>
        )
      })
    })
  })
  return (
    <Menu id={'slide'} left styles={styleResponsive} isOpen={isOpen} noOverlay>
      {items}
    </Menu>
  )
}

export default MenuResponsive
